export const PATH_HOME = "/";
export const PATH_DASHBOARD = "/";
export const PATH_LOGOUT = "/logout";
export const PATH_PROFILE = "/profile";
export const PATH_CAMPAIGNS = "/campaigns";
export const PATH_PRIVACY_POLICY = "/privacy-policy";
// Public support page — also the App Store Connect "Support URL" for the iOS app.
export const PATH_SUPPORT = "/support";

// GETTING STARTED
export const PATH_GETTING_STARTED = "/getting-started";
export const PATH_SETUP_CALENDAR = "/getting-started/setup-calendar";

// SETTINGS
export const PATH_SETTINGS = "/settings";
export const PATH_SETTINGS_PROFILE = "/settings/profile";
export const PATH_SETTINGS_USER_MANAGEMENT = "/settings/user-management";
export const PATH_SETTINGS_INTEGRATIONS = "/settings/integrations";
export const PATH_SETTINGS_BILLING = "/settings/billing";
export const PATH_SETTINGS_DOMAINS = "/settings/domains";
export const PATH_SETTINGS_PIXEL_INSTALL = "/settings/pixel-install";
export const PATH_SETTINGS_DOMAIN_CONNECT = "/settings/domains/connect";
export const PATH_SETTINGS_INTEGRATIONS_HUBSPOT = "/settings/integrations/hubspot";
export const PATH_SETTINGS_INTEGRATIONS_META = "/settings/integrations/meta";
export const PATH_SETTINGS_INTEGRATIONS_GOOGLE_ADS = "/settings/integrations/google-ads";
export const PATH_SETTINGS_INTEGRATIONS_GOOGLE_CALENDAR = "/settings/integrations/google-calendar";
export const PATH_SETTINGS_FIELDS = "/settings/fields";
export const PATH_SETTINGS_AVAILABILITY = "/settings/availability";
export const PATH_SETTINGS_CALL_CENTER = "/settings/call-center";
export const PATH_SETTINGS_INTEGRATIONS_SLACK = "/settings/integrations/slack";
export const PATH_SETTINGS_TRAINING = "/settings/training";


// QUESTIONNAIRES
export const PATH_QUESTIONNAIRES = "/questionnaires";
export const PATH_QUESTIONNAIRES_CREATE = "/questionnaires/create";
export const PATH_QUESTIONNAIRE_EDIT = "/questionnaires/:questionnaireId";

// PRODUCTS
export const PATH_PRODUCTS = "/products";
export const PATH_PRODUCTS_COUPONS = "/products/coupons";

// LEADS
export const PATH_LEADS = "/leads";
export const PATH_LEAD_DETAILS = "/leads/:leadId";
export const getLeadDetailsUrl = (leadId: number | string) => `${PATH_LEADS}/${leadId}`;

// PIPELINES
export const PATH_PIPELINES = "/pipelines";
export const PATH_DEAL_DETAILS = "/pipelines/deals/:dealId";
export const getDealDetailsUrl = (dealId: number | string) => `${PATH_PIPELINES}/deals/${dealId}`;

// CALLS
export const PATH_CALLS = "/calls";

// PROOF NOTIFICATIONS
export const PATH_PROOF_NOTIFICATIONS = "/proof-notifications";
export const PATH_CREATE_PROOF_NOTIFICATIONS = "/proof-notifications/create";
export const PATH_EDIT_PROOF_NOTIFICATION = "/proof-notifications/edit/:notificationId";

// EMAILS
export const PATH_EMAILS = "/emails";
export const PATH_EMAILS_CREATE = "/emails/create";
export const PATH_EMAILS_CREATE_SINGLE = "/emails/create/single";
export const PATH_EMAILS_CREATE_NEWSLETTER = "/emails/create/newsletter";
export const PATH_EMAILS_CREATE_NURTURE_SECUENCE = "/emails/create/nurture-secuence";

//AUTH
export const PATH_LOGIN = "/login";
export const PATH_SIGNUP = "/signup";
export const PATH_FORGOT_PASSWORD = "/forgot-password";
export const PATH_RESET_PASSWORD = "/reset-password";
export const PATH_ACCEPT_INVITE = "/accept-invite";
export const PATH_FORMS = "/forms";

// CALL CENTER
export const PATH_CALL_CENTER = "/call-center";
export const PATH_CALL_CENTER_JOIN = "/call-center/join-meeting/:sessionName";
export const PATH_CALL_CENTER_JOIN_AS_ADMIN = "/call-center/join-meeting-as-admin/:sessionName";
export const PATH_CALL_CENTER_CALL_LEAD = "/call-center/call-lead/:sessionName";
export const PATH_CALL_CENTER_LEAD_RATE = "/call-center/lead-rating/:sessionId";
export const PATH_CALL_CENTER_EOD_REPORT = "/call-center/eod-report";
export const PATH_CALL_CENTER_CLOUD_RECORDINGS = "/call-center/cloud-recordings";
export const PATH_CALL_CENTER_CLOUD_RECORDING_DETAILS = "/call-center/cloud-recordings/:sessionId";
// Sibling segment (not /cloud-recordings/personal-room) so it can't collide
// with the :sessionId details route above.
export const PATH_CALL_CENTER_PERSONAL_ROOM_RECORDINGS = "/call-center/personal-room-recordings";
export const PATH_CALL_CENTER_COMPANY_ROOM = "/call-center/company-room";


// MEETING SCHEDULER
export const PATH_MEETING_SCHEDULER = "/meeting-scheduler";
export const PATH_MANAGE_MEETING_SCHEDULER = "/meeting-scheduler/manage-schedulers";

// ONBOARDING
export const PATH_ONBOARDING = "/onboarding";
export const PATH_ONBOARDING_STEP_1 = "/onboarding/step-1";
export const PATH_ONBOARDING_STEP_2 = "/onboarding/step-2";
export const PATH_ONBOARDING_STEP_3 = "/onboarding/step-3";
export const PATH_ONBOARDING_STEP_4 = "/onboarding/step-4";

// TASKS
export const PATH_TASKS = "/tasks";

// CALENDAR
export const PATH_CALENDAR = "/calendar";

// FUNNELS
export const PATH_FUNNELS = "/funnels";

// TRAINING
export const PATH_TRAINING = "/training";
export const PATH_TRAINING_WEEKLY_REPORT = "/training/weekly-report";
export const PATH_TRAINING_AGENT_PROFILE = "/training/agents/:agentId";
export function pathTrainingAgentProfile(agentId: string) {
    return `/training/agents/${agentId}`;
}
